import { Directive, ElementRef, input, Optional } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appIsOverflowField]',
  standalone: false,
})
export class IsOverflowFieldDirective {
  appIsOverflowField = input.required<boolean>();

  constructor(
    private elementRef: ElementRef,
    @Optional() private matTooltip: MatTooltip,
  ) {}

  ngAfterContentChecked() {
    if (!this.appIsOverflowField()) {
      if (this.matTooltip) {
        this.matTooltip.disabled = false;
      }
      return;
    }

    const element = this.elementRef.nativeElement;

    const curOverflow = element.style.overflow;
    if (!curOverflow || curOverflow === 'visible') element.style.overflow = 'hidden';
    const isOverflowing = element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
    element.style.overflow = curOverflow;

    if (this.matTooltip) {
      this.matTooltip.disabled = !isOverflowing;
    }
  }
}
